import { IDraftData, TDraftStatus } from '@df/catalog/cms/cms-model.interface';
import { IModelData, TLoadDependeciesParams } from '@df/catalog/model';
import { ICmsModel } from '../../../core/resource/model/icms-model';

export const draftStatusOptions: { key: TDraftStatus; title: string }[] = [
    { key: 'new', title: 'New' },
    { key: 'accepted', title: 'Approved' },
    { key: 'published', title: 'Published' }
];

export class ICmsDraft<
    TTargetData extends IModelData = IModelData,
    TTarget extends ICmsModel<TTargetData> = ICmsModel<TTargetData>
> extends ICmsModel<IDraftData<TTargetData>, number> {
    /**
     * Object type id
     */
    static override readonly type = 'draft';

    /**
     * Max verbosity
     */
    override maxVerbosity = 1;

    /**
     * If works with scope data
     */
    override hasScopeData = false;
    /**
     * If model uses cms top bar for saving, undo and redo
     */
    override usesMainSaveBar = true;

    get target(): TTarget {
        return this.app.resources[this.data!.targetType].get(this.data!.target) as TTarget;
    }

    canPreview(): boolean {
        return !!this.data;
    }

    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        super.addDependenciesToLoader(params);
        params.loader.add(this.target.load(1));
    }

    get isPublished() {
        return this.data?.status === 'published';
    }
}
